let locationsData = [
  {
    id: 'shisooaks',
    // disabled: true, openingDate: "visit/call to order",
    label: "Sherman Oaks",
    className: 'night',
    address: ["14120 Ventura Blvd", "Sherman Oaks CA 91423"],
    phone: "8189958824",
    phoneLink: "+18189958824",
    orderLink: "/shermanoaks",
    hours: [
      { day: 'Mon-Sun', hours: '5pm - 9:30pm' },

    ]},
    {
      id: 'shiso',
      // disabled: true, openingDate: "visit/call to order",
      label: "North Hollywood",
      className: 'night',
      address: ["11713 Saticoy St,", "North Hollywood, CA 91605"],
      phone: "(747)208-8898",
      phoneLink: "+17472088898",
      orderLink: "/noho",
      hours: [
        { day: 'Mon-Thu', hours: '11:30am - 3pm, 5-9:30pm' },
        { day: 'Friday', hours: '11:30am - 3pm, 5-10:30pm' },
        { day: 'Saturday', hours: '1pm - 10:30pm' },
        { day: 'Sunday', hours: '1pm - 9:30pm' },
        // { day: 'Fri,Sat', hours: '5pm-1am' },
  
      ]},

    // {
    //   id: 'taronnoho',
    //   label: "North Hollywood",
    //   disabled: true, openingDate: "online ordering coming soon",
    //   // special: "We Moved!",
    //   address: ["12901 Sherman Way, Ste D", "North Hollywood, CA 91605"],
    //   phone: "818-765-7722",
    //   phoneLink: "+18187657722",
    //   orderLink: "/melrose",
    //   // external: true,
    //   hours: [
    //     { day: 'Mon-Sat', hours: '7:30am-7pm' },
    //     { day: 'Sun', hours: '7:30am-4:30pm' },
  
    //   ]},
    //   {
    //     id: 'taronhollywood',
    //     disabled: true, openingDate: "online ordering coming soon",
    //     label: "Hollywood",
    //     className: 'night',
    //     address: ["4950 Hollywood Blvd", "Los Angeles, CA 90027"],
    //     phone: "323-663-4809",
    //     phoneLink: "+13236634809",
    //     orderLink: "/reseda",
    //     hours: [
    //       { day: 'Mon-Sat', hours: '7:30am-7pm' },
    //       { day: 'Sun', hours: '7:30am-4:30pm' },
  
    //     ]},
  
  ]

  export default locationsData